import React from 'react';
import { withFormsy } from 'formsy-react';
import HTMLEditorPreviewPure from 'components/HTMLEditorPreview';

function HTMLEditorPreview({ onChange, setValue, getValue }) {
  const handleChange = (value) => {
    setValue(value)
    onChange && onChange(value)
  }

  return <HTMLEditorPreviewPure
    value={getValue()}
    onChange={handleChange}
  />
}

export default withFormsy(HTMLEditorPreview);
